import React, { useEffect, useState } from "react";
import axios from "axios";
import "./UserManagement.css";
import { useNavigate } from "react-router-dom";
import Header from "../HeaderAdmin";
import Navbar from "../Navbar.js";
import { MdKeyboardArrowLeft, MdOutlineKeyboardArrowRight, MdFirstPage, MdLastPage  } from "react-icons/md";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FAMILY_USERS, GET_ADMIN_USERS, MLT_USERS, USERS_BASE_URL } from "../ApiDetails.js";

function UserManagement() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [adminUsers, setAdminUsers] = useState([]);
  const [familyUsers, setFamilyUsers] = useState([]);
  const [MLTUsers, setMLTUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [isMarsChampion, setIsMarsChampion] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAdminUsers();
    fetchFamilyUsers();
    fetchmltusers();
  }, []);

  useEffect(() => {
    if (adminUsers.length || familyUsers.length || MLTUsers.length) {
      fetchUsers();
    }
  }, [adminUsers, familyUsers, MLTUsers]);

  useEffect(() => {
    calculateTotalPages(filteredUsers);
  }, [filteredUsers]);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(USERS_BASE_URL);
      const data = response.data.map((user) => {
        const coordinatorIds = user.userLookups
          ?.filter(lookup => lookup.typeID === 8 || lookup.typeID === 10)
          ?.flatMap(u => u.coOrdinatorId ? u.coOrdinatorId.split(',').map(Number) : []);
        
        const coordinators = response.data.filter(userC => userC.userLookups
          ?.filter(lookup => lookup.typeID === 8 || lookup.typeID === 10)
          ?.flatMap(u => u.coOrdinatorId ? u.coOrdinatorId.split(',').map(Number) : []).includes(user.id)).map((userC) => userC.firstName+" "+userC.lastName).join(', ');
        const coordNames = response.data.filter(userC => coordinatorIds.includes(userC.id)).map((userC) => userC.firstName+" "+userC.lastName).join(', ');

        const coordString = (coordinators!=="") ? "Coordinated by: " + coordinators : ((coordNames!=="") ? "Coordinates: "+coordNames : "");

        return {
          ...user,
          coordString: coordString,
        };
      });

      setUsers(data);
      setFilteredUsers(data);
      calculateTotalPages(data);
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]);
    }
  };

  const fetchAdminUsers = async () => {
    try {
      const response = await axios.get(GET_ADMIN_USERS);
      setAdminUsers(response.data);
    } catch (error) {
      console.error("Error fetching admin users:", error);
    }
  };

  const fetchFamilyUsers = async () => {
    try {
      const response = await axios.get(FAMILY_USERS);
      setFamilyUsers(response.data);
    } catch (error) {
      console.error("Error fetching family users:", error);
    }
  };

  const fetchmltusers = async () => {
    try {
      const response = await axios.get(MLT_USERS);
      setMLTUsers(response.data);
    } catch (error) {
      console.error('Error fetching mlt users:', error);
    }

  };

  const calculateTotalPages = (data) => {
    const total = Math.ceil(data.length / pageSize);
    setTotalPages(total);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleEditUser = (user) => {
    if (user.id) {
      navigate('/user', { state: { user, userId: user.id } });
    } else {
      console.error("User ID is undefined");
    }
  };

  const filterUsers = (searchString,onlyMarsChampions) => {
    setFilteredUsers(users.filter((user) => {
      const firstName = user.firstName ? user.firstName.toLowerCase() : "";
      const lastName = user.lastName ? user.lastName.toLowerCase() : "";
      const email = user.email ? user.email.toLowerCase() : "";
      const profileString = user.userTypenames.join(", ").toLowerCase();
      const coordString = user.coordString ? user.coordString.toLowerCase() : "";
      handlePageChange(1);

      return ((!onlyMarsChampions) || (onlyMarsChampions && user.marsChampion) ) && ( (searchString==="") ||
        firstName.includes(searchString.toLowerCase()) ||
        lastName.includes(searchString.toLowerCase()) ||
        email.includes(searchString.toLowerCase()) ||
        ((profileString!=="") && profileString.includes(searchString.toLowerCase())) ||
        ((coordString!=="") && coordString.includes(searchString.toLowerCase()))
      );
    }));
  };


  const currentPageData = filteredUsers.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage + 1 < maxPageNumbersToShow) {
      startPage = Math.max(1, endPage - maxPageNumbersToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  const handleSearchQueryChange = (e) => {
    setSearchQuery(e.target.value);
    filterUsers(e.target.value,isMarsChampion);
  };

  return (
    <>
      <Header />
      <div className="reportsContainerPadding">
        <Navbar />
        <div className="container-fluid">
          <div className="row m-4 mt-1">
            <div className="m-2 bg-light rounded p-3">
              <div className="large-custom-font">User Management</div>
            </div>
            <div className="m-2 bg-light rounded p-0">
              <div className="m-2">
                <div className="input-group align-items-center">
                  <input
                    type="text"
                    className="form-control p-2"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={handleSearchQueryChange}
                    style={{
                      flex: 1,
                      border: "none",
                      backgroundColor: "#f6f6fb",
                      paddingLeft: "10px",
                      fontSize: "14px",
                      color: "#6a5bb4",
                    }}
                  />
                  <div  style={{marginLeft:"1%",width:"16%"}}>
                  <label className="switch" style={{width:"80%", textAlign:"right"}}>
                    <span  style={{width:"100%"}}>Only Mars Champions</span>
                  </label>
                  <label className="switch">
                    <input type="checkbox" name="isMarsChampionId"
                      onChange={e => {
                        setIsMarsChampion(e.target.checked);
                        filterUsers(searchQuery,e.target.checked);
                      }}
                      checked={isMarsChampion}
                    />
                    <span className="slider round"/>
                  </label>
                  </div>
                  <span
                    className="input-group-text"
                    style={{
                      color: "#6a5bb4",
                      cursor: "pointer",
                      padding: "0 10px",
                      border: "none",
                      backgroundColor: "#f6f6fb",
                    }}
                  >
                    <i className="fa fa-search" style={{ fontSize: "16px" }}></i>
                  </span>
                </div>
              </div>
              <div className="container-fluid listitemsadmin listitems p-3">
                <div className="table-responsive">
                  <div className="table">
                    <div className="row custom-table-font-header bg-light p-3 rounded m-3">
                      <div className="col-12 col-md-1">FIRST NAME</div>
                      <div className="col-12 col-md-2">LAST NAME</div>
                      <div className="col-12 col-md-3">E-MAIL</div>
                      <div className="col-12 col-md-1">PROFILE</div>
                      <div className="col-12 col-md-2">MARS CHAMPION</div>
                      <div className="col-12 col-md-2">COORDINATION</div>
                      <div className="col-12 col-md-1"></div>
                    </div>
                    {currentPageData.length > 0 ? (
                      currentPageData.map((user, index) => (
                        <div
                          className="row custom-table-tr bg-light p-3 rounded m-3 align-items-center"
                          key={index}
                        >
                          <div className="col-12 col-md-1">{user.firstName}</div>
                          <div className="col-12 col-md-2">{user.lastName}</div>
                          <div className="col-12 col-md-3">{user.email}</div>
                          <div className="col-12 col-md-1">{user.userTypenames.join(", ")}</div>
                          <div className="col-12 col-md-2">{user.marsChampion ? "Yes" : "No"}</div>
                          <div className="col-12 col-md-2">{user.coordString}</div>
                          <div className="col-12 col-md-1 text-end">
                            <FontAwesomeIcon
                              icon={faEdit}
                              onClick={() => handleEditUser(user)}
                              style={{
                                cursor: "pointer",
                                fontSize: "14px",
                                color: "#0000a0",
                              }}
                            />
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="row bg-light p-2 rounded m-3 align-items-center">
                        <div className="col-12 text-center">No users found</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="paging align-items-center" style={{userSelect: 'none'}}>
                <span className="centered-text">
                    {(totalPages>0) && (<>{(currentPage - 1) * pageSize + 1}-{Math.min(currentPage * pageSize, filteredUsers.length)} OF{" "}</>)}
                    {filteredUsers.length} ELEMENTS &nbsp;&nbsp;
                </span>
                <nav>
                    <ul className="pagination justify-content-end" style={{ marginBottom: "17px", cursor: "pointer" }}>
                        <li className={`page-item ${((totalPages===0) || currentPage === 1) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageChange(1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdFirstPage /></span>
                        </li>
                        <li className={`page-item ${((totalPages===0) || currentPage === 1) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageChange(currentPage - 1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdKeyboardArrowLeft /></span>
                        </li>
                        {getPageNumbers().map((number) => (
                            <li key={number} className={`page-item ${currentPage === number ? "active" : ""}`}>
                                <span className="page-link" onClick={() => handlePageChange(number)} style={{ fontSize: "12px", padding: "4px 8px" }}>{number}</span>
                            </li>
                        ))}
                        <li className={`page-item ${((totalPages===0) || currentPage === totalPages) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageChange(currentPage + 1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdOutlineKeyboardArrowRight /></span>
                        </li>
                        <li className={`page-item ${((totalPages===0) || currentPage === totalPages) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageChange(totalPages)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdLastPage /></span>
                        </li>
                    </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserManagement;